export default function AcceptIcon() {
  return (
    <svg width='70px' height='75px' viewBox='0 0 70 75' version='1.1' xmlns='http://www.w3.org/2000/svg'>
      <title>icon-check</title>
      <g stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
        <g id='icon-check'>
          <circle id='Oval-Copy-37' fill='#000000' cx='35' cy='35' r='35'></circle>
          <circle id='Oval-Copy-38' fill='#000000' cx='35' cy='40' r='35'></circle>
          <circle id='Oval-Copy-39' fill='#FD6687' cx='35' cy='35' r='32'></circle>
          <polyline stroke='#FFFFFF' strokeWidth='3' points='20 34.5819497 30.2640104 44.84596 50.1099704 25'></polyline>
        </g>
      </g>
    </svg>
  );
}
